module.exports = __webpack_public_path__ + "images/illustrations/reach-icon-person-out-6e764c1b6b9323718e406cf6e7a889f9.svg";